/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {personalizedAdsOptOut} from '../api'

export const useMutationPersonalizedAdsOptOut = createReactQueryMutationHook('personalizedAdsOptOut', personalizedAdsOptOut)
